import React, { useEffect, useState } from 'react';
import ContentFrequentQuestions from 'components/ContentFrequentQuestions';
import Layout from 'components/Layout';
import SessionFactory from 'factories/Session';

const FrequentQuestions = () => {
  const [loadData, setLoadData] = useState(false);

  useEffect(() => {
    const sessValid = SessionFactory.validation();
    if (sessValid !== null) {
      setLoadData(true);
    }
  }, []);

  return (
    <div>
      {/* Si loadData es true, renderiza el contenido con las clases 'mi-cuenta lo-que-sigue', de lo contrario, solo renderiza el contenido sin aplicar clases */}
      <div className={loadData ? 'mi-cuenta cupones is-logged' : ''}>
        <Layout showBanner={false}>
          <ContentFrequentQuestions />
        </Layout>
      </div>
    </div>
  );
}

export default FrequentQuestions;
